/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getTenantByIdRoute, getTenantsRoute } from "../../lib/routes/tenants";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { getCompanyIdentityAttributeRus } from "../../lib/utils/getTenantProperty";
import { getPropertiesRoute } from "../../lib/routes/properties";

const initialState = {
  tenants: [],
  tenantsLoading: rtkRequestStatusCodes.idle,
  tenant: {},
  tenantLoading: rtkRequestStatusCodes.idle,
  tenantProperties: [],
  tenantPropertiesDto: [],
  tenantPropertiesLoading: rtkRequestStatusCodes.idle,
};

const fetchTenants = createAsyncThunk("tenants/fetchAll", async () => {
  const response = axios.get(getTenantsRoute());
  const { data } = await response;
  return data;
});

const fetchTenantById = createAsyncThunk("tenants/fetchTenantById", async ({ tenantId }) => {
  const response = axios.get(getTenantByIdRoute(tenantId));
  const { data } = await response;
  return data;
});

const fetchTenantProperties = createAsyncThunk("tenants/fetchProperties", async (tenantId) => {
  const response = axios.get(
    getPropertiesRoute({ objectTypeSysname: "tenant", objectId: tenantId })
  );
  const { data } = await response;
  return data;
});

const getTenantPropertyName = (alias) => {
  const dirtyName = alias.split(".");
  const name = dirtyName[dirtyName.length - 1]
    .split("_")
    .map((item, i) => {
      if (i > 0) {
        return `${item[0].toUpperCase()}${item.slice(1)}`;
      }
      return item;
    })
    .join("");

  return name;
};

export const tenantsSlice = createSlice({
  name: "tenants",
  initialState,
  extraReducers: {
    [fetchTenants.fulfilled]: (state, action) => {
      state.tenants = action.payload;
      state.tenantsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchTenants.pending]: (state) => {
      state.tenantsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchTenants.rejected]: (state) => {
      state.tenantsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchTenantById.fulfilled]: (state, action) => {
      state.tenant = action.payload;
      state.tenantLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchTenantById.pending]: (state) => {
      state.tenantLoading = rtkRequestStatusCodes.pending;
    },
    [fetchTenantById.rejected]: (state) => {
      state.tenantLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchTenantProperties.pending]: (state) => {
      state.tenantPropertiesLoading = rtkRequestStatusCodes.pending;
    },
    [fetchTenantProperties.fulfilled]: (state, action) => {
      const tenantProperties = {};
      action.payload.forEach(({ numberValue, stringValue, propertyType }) => {
        const value = numberValue || stringValue;
        const alias = propertyType?.alias;
        if (alias) {
          const tenantPropertyName = getTenantPropertyName(alias);
          tenantProperties[tenantPropertyName] = value;
          if (tenantPropertyName === "companyIdentityAttribute") {
            tenantProperties.companyIdentityAttributeRus = getCompanyIdentityAttributeRus(value);
          }
        }
      });
      // TODO Sumaev
      state.tenantProperties = tenantProperties;
      state.tenantPropertiesDto = action.payload;
      state.tenantPropertiesLoading = rtkRequestStatusCodes.fulfilled;
    },
  },
});

const { reducer } = tenantsSlice;

export { fetchTenants, fetchTenantById, fetchTenantProperties, reducer };
